import React, { Component, lazy, Suspense } from 'react';

// only load the 3X Catalog Import component pages when requested
const summaryPage = lazy(() => import('./XmlCatalogImportSummary'));
const templatePage = lazy(() => import('./XmlCatalogImportTemplate'));
const fullSamplePage = lazy(() => import('./XmlCatalogImportFullSample'));

class XmlCatalogImport extends Component {
  getCatalogImportPage = (pageTitle) => {
    switch(pageTitle)
    {
      default:
        // the 3DX Catalog XML Import documentation page
      case 'summary':
        return { Component: summaryPage, LoadingMsg: "Loading 3DX Catalog XML Import documentation..." };
        // the 3DX Catalog XML Import Template document page
        case 'template':
        return { Component: templatePage, LoadingMsg: "Loading 3DX Catalog XML Import Template document..." };
        // the 3DX Catalog XML Import Full Sample document page
        case 'sample':
        return { Component: fullSamplePage, LoadingMsg: "Loading 3DX Catalog XML Import Full Sample document..." };
    }
  }

  handleDownload = async (downloadLink) => {
    const fileName = downloadLink.substring(downloadLink.lastIndexOf('/') + 1);

    try {
      const response = await fetch(downloadLink);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error occurred while downloading the XML file:', error);
    }
  }

  render () {
    // get the 3DX Catalog Import page we want to show, will be the URL parameter defined as id in the router
    const CatalogImportPage = this.getCatalogImportPage(this.props.match.params.id);
    return (
      <Suspense fallback={<div>{CatalogImportPage.LoadingMsg}</div>}>
        <CatalogImportPage.Component {...this.props} handleDownload={this.handleDownload}/>
        <br></br>
      </Suspense>
    );
  }
}

export default XmlCatalogImport;



// WEBPACK FOOTER //
// ./src/containers/XmlCatalogImport/XmlCatalogImport.js